import * as Immutable from "immutable";
import { ImmutableObject } from "../../../../shared/immutableObject";

export class VariableControl extends ImmutableObject {

  protected readonly VARIABLE_ID = "variableId";
  protected readonly NUMERIC_FORMAT = "numericFormat";

  get variableId(): number { return this.getInternalValue<number>(this.VARIABLE_ID); }
  setVariableId(variableId: number): this { return this.setInternalValue(this.VARIABLE_ID, variableId); }

  get numericFormat(): string { return this.getInternalValue<string>(this.NUMERIC_FORMAT); }
  setNumericFormat(numericFormat: string): this { return this.setInternalValue(this.NUMERIC_FORMAT, numericFormat); }
}